module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAAXNSR0IArs4c6QAAAIJJREFUKFOl0csJgDAQRdF5YjHqPqQcF7qwC2MfWo+IBWgxwpMYBH/RgNlkM/cQJpCfBz972YB+mHIRtgDiEJDkEkVSaZV1GzCMc0GyDYn3GQClVokDHDLVpJgQBBCjVdrY2dMOQpBjfAO+XnKNHwEf8hR7gSvii1+B/XfsbbftW+4KAaQ5C6zq61sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/img(10).png
// module id = P4ZW
// module chunks = 1